import React, { useState } from 'react';
import { Button, TextField, Box, Container, Avatar, Typography, Tooltip, Link, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import HowToRegIcon from '@mui/icons-material/HowToReg';

export default function Login() {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [msg, setMsg] = useState(null)
  const navigate = useNavigate()
  const [registerState, setRegisterState] = useState(false)
  const handleSubmit = e => {
    e.preventDefault()
    if (registerState)
      axios.post('/api/register', {username, password})
      .then(({data : {success, msg}}) => {
        setMsg({severity: success ? "success" : "error", text: msg})
      })
    else
      axios.post('/api/login', {username, password})
        .then(({data : {success, msg}}) => {
          if (success)
            navigate("/")
          else
          {
            setMsg({severity: "error", text: msg})
            // highlight all text in the password field to make it easier to retype
            document.querySelector('input[type="password"]').select()
          }
        })
  }
  const toggleRegister = () => {
    setRegisterState(prev => !prev)
    setMsg(null)
  }
  const valid = username && password
  return (
    <Container component="main" maxWidth="xs" sx={{ display: 'flex', minHeight: '100vh', justifyContent: 'center', alignItems: 'center', pb: 8 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1 }}>
          {registerState ? <HowToRegIcon /> : <LockOutlinedIcon />}
        </Avatar>
        <Typography component="h1" variant="h5">
          {registerState ? "Register" : "Login"}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            fullWidth
            label="Username"
            autoFocus
            value={username}
            onChange={e => {
              setUsername(e.target.value)
              // clear any previous error message
              setMsg(null)
            }}
            autoComplete="username"
          />
          <TextField
            margin="normal"
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={e => {
              setPassword(e.target.value)
              // clear any previous error message
              setMsg(null)
            }}
            autoComplete={registerState ? "new-password" : "current-password"}
          />
          {msg && (
            <Alert severity={msg.severity}>
              {msg.text}
            </Alert>
          )}
          {registerState &&
            <Alert severity="warning">
              After registering, reach out to <Link href={`mailto:me@simonpshen.com?subject=[Frab] Account Activation&body=Please activate account for username=${username}`} color="inherit" underline="hover">me@simonpshen.com</Link> to get your account activated.
            </Alert>
          }
          <Tooltip title="Ready to empty your mind?" followCursor>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2, mb: 2 }}
              disabled={!valid}
            >
              {registerState ? "Register" : "Login"}
            </Button>
          </Tooltip>
        </Box>
        <Typography sx={{ pb: 2 }}>
          Welcome! This web app serves as a companion in the wet lab that tracks all your samples (their storage locations, concentrations, genetic identities, etc.); automatically calculates master mixes and other dimensional analyses; and keeps track of the progress of your cells' growth, cloning workflows, etc.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          <Link href="#" color="inherit" underline="hover" onClick={toggleRegister}>
            {registerState ? "Back to Login" : "Create an Account"}
          </Link>
          {" | "}
          <Link href="/tasks/inventory/privacy" color="inherit" underline="hover">
            Privacy Policy
          </Link>
        </Typography>
      </Box>
    </Container>
  )
}
